module.exports = __webpack_public_path__ + "static/img/logo22.5ec6bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo22.png
// module id = KirY
// module chunks = 3